import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IVehicleQueryOptions } from "@app/interfaces/IVehicleQueryOptions";
import { IEngineerAccount, IEngineerDevice, IEngineerProduct, IEngineerVehicle } from "@app/main/modules/foundation/_models/commissioning/engineerAssetModels";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class EngineerAssetsService {
    constructor(private readonly http: HttpClient) { }

    // Vehicles
    getVehicles(options: IVehicleQueryOptions): Observable<IEngineerVehicle[]> {
        return this.http.get<IEngineerVehicle[]>(`/api/engineer/assets/vehicles`, { params: options as HttpParams });
    }

    saveVehicle(vehicle: IEngineerVehicle): Observable<IEngineerVehicle> {
        return this.http.post<number>(`/api/engineer/assets/vehicles`, vehicle)
            .pipe(map(newVehicleId => {
                vehicle.VehicleId = newVehicleId;
                return vehicle;
            }));
    }

    // Devices
    getDevices(): Observable<IEngineerDevice[]> {
        return this.http.get<IEngineerDevice[]>(`/api/engineer/assets/devices`);
    }

    // Products
    getProducts(): Observable<IEngineerProduct[]> {
        return this.http.get<IEngineerProduct[]>(`/api/engineer/assests/products`);
    }

    // Accounts
    getAccounts(): Observable<IEngineerAccount[]> {
        return this.http.get<IEngineerAccount[]>(`/api/engineer/assets/accounts`)
    }
}
